// Environment configuration for frontend
// This file provides environment variables to the frontend

export const environment = {
  // GitLab configuration - try multiple sources
  GITLAB_TOKEN: process.env.REACT_APP_GITLAB_TOKEN || process.env.GITLAB_TOKEN || 'glpat-Q-zTLEuffuzyyY6jsC3s',
  REACT_APP_GITLAB_TOKEN: process.env.REACT_APP_GITLAB_TOKEN || 'glpat-Q-zTLEuffuzyyY6jsC3s',
  
  // SonarQube configuration
  REACT_APP_SONAR_TOKEN: process.env.REACT_APP_SONAR_TOKEN || 'sqa_8588208505fd51adf604a9319ccabbcc73d8dc9d',
  
  // Debug information
  NODE_ENV: process.env.NODE_ENV || 'development',
  
  // Log environment variables for debugging
  debug: () => {
    console.log('🔑 Environment variables check:');
    console.log('REACT_APP_GITLAB_TOKEN:', process.env.REACT_APP_GITLAB_TOKEN ? 'Present' : 'Missing');
    console.log('GITLAB_TOKEN:', process.env.GITLAB_TOKEN ? 'Present' : 'Missing');
    console.log('Final gitlabToken:', (process.env.REACT_APP_GITLAB_TOKEN || process.env.GITLAB_TOKEN || 'glpat-Q-zTLEuffuzyyY6jsC3s') ? 'Present' : 'Missing');
    console.log('REACT_APP_SONAR_TOKEN:', process.env.REACT_APP_SONAR_TOKEN ? 'Present' : 'Missing');
    console.log('Hardcoded fallback token:', 'glpat-Q-zTLEuffuzyyY6jsC3s' ? 'Present' : 'Missing');
  }
};

// Export individual values for easy access
export const GITLAB_TOKEN = environment.GITLAB_TOKEN;
export const SONAR_TOKEN = environment.REACT_APP_SONAR_TOKEN;
